// extracted by mini-css-extract-plugin
module.exports = {"Slide":"Banner_Slide__3JslS","Banner":"Banner_Banner__2_mpC","bannerImg":"Banner_bannerImg__1CT4S","content":"Banner_content__r_4Fh"};